import React from "react";
import { TreeSelect, Form } from "antd";
import { Controller } from "react-hook-form";
import { getError } from "../../../utils/form";
const { SHOW_CHILD } = TreeSelect;

const itemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
    lg: { span: 10 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
    lg: { span: 14 },
  },
};

const ControlledTreeSelect = ({
  control,
  errors,
  name,
  label,
  required,
  options,
  loading,
}) => {
  const error = getError({ errors, name });
  const tProps = {
    treeData: options,
    treeCheckable: true,
    showCheckedStrategy: SHOW_CHILD,
    placeholder: "Click here to select",
    style: {
      width: "100%",
    },
    loading: loading,
  };
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <Form.Item
          label={label}
          {...itemLayout}
          required={required}
          labelAlign="left"
          validateStatus={error ? "error" : "success"}
          help={error?.message}
        >
          <TreeSelect {...field} {...tProps}>
            {options}
          </TreeSelect>
        </Form.Item>
      )}
    />
  );
};

export default ControlledTreeSelect;
